import { Injectable, isDevMode } from '@angular/core';

@Injectable()
export class LogService {
    static log(module: string, message: any, forced = false) {
        if (isDevMode() || forced) {

            if (typeof message === 'object') {
                message = JSON.stringify(message);
            }
            //console.log('[DEBUG] [' + module + '] ' + message);
        }
    }
}

